import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { CartContext } from '../App';

const Cart = React.memo(() => {
  const { cart, removeFromCart, updateQuantity } = useContext(CartContext);

  const getItemPrice = (item) => {
    if (typeof item.price === 'number') return item.price;
    if (item.prices && typeof item.prices === 'object') {
      const first = Object.values(item.prices)[0];
      return typeof first === 'number' ? first : 0;
    }
    return 0;
  };

  const getItemImage = (item) => {
    if (Array.isArray(item.images)) return item.images[0];
    if (item.images && typeof item.images === 'object') {
      return Object.values(item.images)[0];
    }
    return 'https://via.placeholder.com/100x100?text=No+Image';
  };

  const total = cart.reduce((sum, item) => {
    const price = getItemPrice(item);
    return sum + price * (item.quantity || 0);
  }, 0);

  return (
    <div
      style={{
        padding: '3rem 2rem',
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        margin: '2rem auto',
        maxWidth: '900px',
      }}
    >
      <h2 className="cart-container-heading">Shopping Cart</h2>

      {cart.length === 0 ? (
        <p
          style={{
            fontSize: '1.1rem',
            color: '#999',
            textAlign: 'center',
            padding: '2rem',
          }}
        >
          Your cart is empty.
        </p>
      ) : (
        <>
          {cart.map((item) => {
            const itemPrice = getItemPrice(item);

            return (
              <div
                key={`${item.id}-${item.selectedSize || ''}-${item.selectedColor || ''}`}
                className="cart-item"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '1.5rem',
                  padding: '1rem',
                  background: '#f9f9f9',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                }}
              >
                <img
                  src={getItemImage(item)}
                  alt={item.name}
                  style={{
                    width: '100px',
                    height: '100px',
                    objectFit: 'contain',
                    borderRadius: '4px',
                  }}
                  onError={(e) => {
                    e.target.src =
                      'https://via.placeholder.com/100x100?text=No+Image';
                  }}
                />

                <div style={{ marginLeft: '1.5rem', flex: 1 }}>
                  <h4>{item.name}</h4>

                  {item.selectedSize && <p>Size: {item.selectedSize}</p>}
                  {item.selectedColor && <p>Color: {item.selectedColor}</p>}

                  <p>
                    ${itemPrice} x {item.quantity} ={' '}
                    <span
                      style={{ color: '#d4af37', fontWeight: '600' }}
                    >
                      ${(itemPrice * item.quantity).toFixed(2)}
                    </span>
                  </p>

                  <input
                    type="number"
                    value={item.quantity}
                    min="1"
                    onChange={(e) =>
                      updateQuantity(
                        item.id,
                        Math.max(1, parseInt(e.target.value, 10) || 1)
                      )
                    }
                    style={{
                      width: '60px',
                      padding: '0.5rem',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                    }}
                  />

                  <button
                    onClick={() => removeFromCart(item.id)}
                    style={{
                      marginLeft: '1rem',
                      background: 'transparent',
                      border: '1px solid #d4af37',
                      color: '#d4af37',
                      padding: '0.4rem 0.8rem',
                      cursor: 'pointer',
                    }}
                  >
                    Remove
                  </button>
                </div>
              </div>
            );
          })}

          <h3 className="cart-total">Total: ${total.toFixed(2)}</h3>

          <div className="checkout-button-wrapper">
            <Link to="/checkout">
              <button style={{ cursor: 'pointer' }}>
                Proceed to Checkout
              </button>
            </Link>
          </div>
        </>
      )}
    </div>
  );
});

export default Cart;
